import LegalLayout, { Section } from "@/components/LegalLayout";
import { SITE } from "@/data/site";

export default function Cookies() {
  return (
    <LegalLayout
      title="Cookie Policy"
      description="How Kinect Nova AI uses cookies and similar technologies on our website."
      path="/cookies"
      intro={`This Cookie Policy explains how ${SITE.name} uses cookies and similar technologies on our website to recognize you, remember your preferences and understand how the site is used.`}
    >
      <Section heading="1. What are cookies?">
        <p>Cookies are small text files placed on your device when you visit a website. They are widely used to make websites work, improve efficiency and provide reporting information. Similar technologies include local storage, pixels and SDKs.</p>
      </Section>

      <Section heading="2. Types of cookies we use">
        <ul className="list-disc space-y-1 pl-6">
          <li><strong>Strictly necessary:</strong> required for the website to function, such as remembering your light/dark theme preference and security features.</li>
          <li><strong>Analytics:</strong> help us understand how visitors interact with the site so we can improve it. These are only set with your consent where required.</li>
          <li><strong>Functional:</strong> remember choices you make to provide a more personalized experience.</li>
        </ul>
        <p>We do not use cookies for cross-site advertising.</p>
      </Section>

      <Section heading="3. Managing cookies">
        <p>Most browsers let you control cookies through their settings, including blocking or deleting them. Please note that disabling certain cookies may affect the functionality of the website. Where required by law, we will request your consent before setting non-essential cookies.</p>
      </Section>

      <Section heading="4. Third-party cookies">
        <p>Some analytics and infrastructure providers may set their own cookies subject to their respective privacy policies. We only work with providers that maintain appropriate data protection standards.</p>
      </Section>

      <Section heading="5. Changes to this policy">
        <p>We may update this Cookie Policy from time to time. Any changes will be posted on this page with an updated date.</p>
      </Section>

      <Section heading="6. Contact">
        <p>For questions about our use of cookies, contact {SITE.supportEmail}.</p>
      </Section>
    </LegalLayout>
  );
}
